import {
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
  Provider,
} from '@angular/core';
import {
  ApplicationStore,
  getModuleGroupByName,
  SOFTLINE_FEATURE_APPLICATIONS,
} from '@softline/application';
import { provideSoftAppsModule, withLazySoftAppsModuleTranslation, withSoftAppsModuleRoutes } from '@softapps/core';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import { default as de } from '../i18n/de.json';
import { default as deTitles } from '../i18n/de.titles.json';
import { produktkalkulationRoutes } from './produktkalkulation.routes';
import { SOFTLINE_PERMISSION_PRODUKTKALKULATION } from './produktkalkulation.shared';

export function provideProduktkalkulationModule() {
  return [
    provideSoftAppsModule(
      {
        name: 'produktkalkulation',
        title: '#PRODUKTKALKULATION.APP',
        icon: 'fa-regular fa-calculator',
        route: '/produktkalkulation',
        permission: SOFTLINE_PERMISSION_PRODUKTKALKULATION,
        group: getModuleGroupByName('Schmuck'),
      },
      withSoftAppsModuleRoutes({ app: produktkalkulationRoutes }),
      withLazySoftAppsModuleTranslation({
        eager: { de: deTitles },
        lazy: { de: () => import('../i18n/de.json') },
      })
    ),
  ];
}

export const produktkalkulationProviders: (Provider | EnvironmentProviders)[] = [
  provideEnvironmentInitializer(() => {
    const store = inject(Store);
    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'produktkalkulation',
      language: 'de',
      translations: de,
    });
    store.commit(SOFTLINE_FEATURE_APPLICATIONS, ApplicationStore.mutations.add, {
      name: '#PRODUKTKALKULATION.APP',
      icon: 'fa-regular fa-calculator',
      route: '/produktkalkulation',
      permission: SOFTLINE_PERMISSION_PRODUKTKALKULATION,
      group: getModuleGroupByName('Schmuck'),
    });
  }),
];
